import { render } from "./publicWelfareDetail.vue?vue&type=template&id=279646e6"
import script from "./publicWelfareDetail.vue?vue&type=script&lang=js"
export * from "./publicWelfareDetail.vue?vue&type=script&lang=js"

import "./publicWelfareDetail.vue?vue&type=style&index=0&id=279646e6&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__